/**
 * Resource identifiers for withResourceProtection / hasResource.
 * Sync names with login API resource_mappings when gating access.
 */
export const MONITOR_RESOURCE_MONITOR_PAGE = 'Monitor';
export const MONITOR_RESOURCE_NURTURING_CANDIDATE_AUDIT =
  'NurturingCandidateAuditPage';
export const MONITOR_RESOURCE_NURTURING_PLAN_EXECUTION =
  'NurturingPlanExecutionPage';
